import moment from 'moment';

const UNSET_CHOICE_VALUE = '-1';
const DATE_INPUT_FORMATS = ['MM/DD/YYYY, hh:mm A', 'MM/DD/YYYY', 'YYYY-MM-DD', moment.ISO_8601];

// Hardcoded field names for the "Activity Due Date" composite editor in ActivityDetail/index.jsx
export const DUE_DATE_FIELD_KEY = 'dueDate';
export const DUE_DATE_TZ_FIELD_KEY = 'dueDateTzDll';

function stripHashSuffix(key) {
  if (typeof key !== 'string') return key;
  return key.replace(/_[0-9a-f]{6,}$/i, '');
}

function extractTypeToken(key) {
  const stable = stripHashSuffix(key);
  const parts = String(stable).split('_');
  return parts.length >= 2 ? parts[parts.length - 1].toLowerCase() : '';
}

function toUnixSeconds(value) {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value > 1e12 ? Math.floor(value / 1000) : Math.floor(value);
  }
  if (value instanceof Date) return Math.floor(value.getTime() / 1000);
  const parsed = moment(value, DATE_INPUT_FORMATS, true);
  if (parsed.isValid()) return parsed.unix();
  const loose = moment(value);
  return loose.isValid() ? loose.unix() : null;
}

function coerceValueByType(value, typeToken) {
  if (typeToken === 'datetime' || typeToken === 'date') {
    return toUnixSeconds(value);
  }
  if (typeToken === 'singlechoicelist' || typeToken === 'multiplechoicelist') {
    if (value === UNSET_CHOICE_VALUE || value === '' || value === null || value === undefined) {
      return null;
    }
    return value;
  }
  if (typeToken === 'checkbox') {
    return value === true || value === 'true' || value === 1 ? 'Yes' : 'No';
  }
  return value === undefined ? null : value;
}

function resolveTemplateFieldKey(fieldsMeta, key) {
  const stableKey = stripHashSuffix(key);
  const match = fieldsMeta.find((f) => {
    const candidates = [f?.fieldKey, f?.fieldName, f?.cf_field_name, f?.Name].filter(Boolean);
    return candidates.includes(key) || candidates.map(stripHashSuffix).includes(stableKey);
  });
  return match?.mapFieldKey || stableKey;
}

export function buildInlineActivityFieldPatch(editedFields, fieldsMeta = []) {
  const activity = {};
  const templateFields = {};
  Object.entries(editedFields).forEach(([key, rawValue]) => {
    if (rawValue === undefined) return;
    if (key === DUE_DATE_FIELD_KEY) {
      activity.due_date = toUnixSeconds(rawValue);
      return;
    }
    if (key === DUE_DATE_TZ_FIELD_KEY) {
      activity.due_date_tz = rawValue;
      return;
    }
    const typeToken = extractTypeToken(key);
    const semanticKey = resolveTemplateFieldKey(fieldsMeta, key);
    templateFields[semanticKey] = coerceValueByType(rawValue, typeToken);
  });
  if (Object.keys(templateFields).length > 0) {
    activity.template_fields = templateFields;
  }
  return { activity };
}
